import { render } from "./CreateSharedFS.vue?vue&type=template&id=17663c39&scoped=true"
import script from "./CreateSharedFS.vue?vue&type=script&lang=js"
export * from "./CreateSharedFS.vue?vue&type=script&lang=js"

import "./CreateSharedFS.vue?vue&type=style&index=0&id=17663c39&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17663c39"]])

export default __exports__